import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const ShopIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [shopPageIndex, setShopPageIndex] = useState(1);
    const [shopPageSize, setShopPageSize] = useState(store.main.pageSize);
    const [shopIdList, setShopIdList] = useState([]);
    const [shopTotal, setShopTotal] = useState(0);
    const [shopList, setShopList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/shop/index"});

            handleSearchShop();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadShop(shopPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadShop(shopPageIndex, shopPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchShop = () => {
        handleLoadShop(1, shopPageSize);
    };

    const handleLoadShop = (shopPageIndex, shopPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = shopPageIndex;
        data.pageSize = shopPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/shop/business/website/v1/list",
            data: data,
            success: (response) => {
                setShopPageIndex(shopPageIndex);
                setShopPageSize(shopPageSize);
                setShopIdList([]);
                setShopTotal(response.data.total);
                setShopList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddShop = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/shop/add",
        });
    };

    const handleEditShop = (shopId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/shop/edit/" + shopId,
        });
    };

    const handleDelShop = () => {
        if (shopIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/shop/business/website/v1/delete",
                    data: {
                        shopIdList: shopIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setShopIdList([]);

                        handleLoadShop(shopPageIndex, shopPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeShopIdList = (shopIdList) => {
        setShopIdList(shopIdList);
    };

    const handleChangeShopPagination = (shopPageIndex, shopPageSize) => {
        handleLoadShop(shopPageIndex, shopPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddShop}>
                                新增
                            </Button>
                            <Button loading={isLoad} disabled={shopIdList.length == 0} icon={<DeleteOutlined />} size="large" onClick={handleDelShop}>
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchShop}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店名称"
                                labelAlign={"left"}
                                name="shopName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店名称" onPressEnter={handleSearchShop} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商户名称"
                                labelAlign={"left"}
                                name="merchantName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入商户名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入商户名称" onPressEnter={handleSearchShop} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店代码"
                                labelAlign={"left"}
                                name="shopCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店代码" onPressEnter={handleSearchShop} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.shopId}
                        columns={[
                            {
                                title: "门店名称",
                                dataIndex: "shopName",
                            },
                            {
                                title: "商户名称",
                                dataIndex: "merchantName",
                            },
                            {
                                title: "门店代码",
                                width: 100,
                                dataIndex: "shopCode",
                            },
                            {
                                title: "门店电话",
                                dataIndex: "shopTel",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditShop(record.shopId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={shopList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: shopIdList,
                            onChange: handleChangeShopIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: shopPageIndex,
                            pageSize: shopPageSize,
                            total: shopTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeShopPagination,
                            onShowSizeChange: handleChangeShopPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

ShopIndex.propTypes = {};

ShopIndex.defaultProps = {};

export default ShopIndex;
